<template>
  <div id="app">
    <InquirePage v-if="type === 1" @search="search"></InquirePage>

    <ListPage
      v-if="type === 2"
      :order="orderText"
      :infoList="infoList"
      @search="search"
    ></ListPage>

    <EmptyPage
      v-if="type === 3"
      :order="orderText"
      @backHome="backHome"
      @search="search"
    ></EmptyPage>
  </div>
</template>

<script>
import InquirePage from "./components/Inquire";
import EmptyPage from "./components/Empty";
import ListPage from "./components/List";
import { Toast } from "vant";
import axios from "./request";

export default {
  name: "App",
  components: {
    InquirePage,
    EmptyPage,
    ListPage,
  },
  data() {
    return {
      type: 1, //1 首页 2 查单结果页 3 空页面
      infoList: [],
      orderText: null,
    };
  },
  methods: {
    search(orderText) {
      this.orderText = orderText;
      if (!orderText) {
        Toast({
          className: "toast-msg",
          message: "请输入订单号",
        });
        return;
      }
      orderText = orderText ? Number(orderText): null;
      //上传文件到服务器
      // 从 URL 查询参数中获取 teamId
      const urlParams = new URLSearchParams(window.location.search);
      const teamId = urlParams.get('teamId');
      let formData = {'orderId': orderText, 'teamId': teamId};

      //window.location.href + 'dream/order/queryOrderDetails'
      axios
        .post("/wxapi/orderquery/queryByTeam", formData)
        .then((res) => {
          // 检查返回状态
          if (res.data.code !== 200) {
            this.type = 3;
            Toast({
              className: "toast-msg",
              message: res.data.msg || "查询失败",
            });
            return;
          }
          
          // 检查是否有数据
          if (!res.data.rows || res.data.rows.length === 0) {
            this.type = 3;
            Toast({
              className: "toast-msg",
              message: "订单不存在/等5分钟后查询(订单存在延迟)",
            });
            return;
          }
          
          this.infoList = res.data.rows.map(this.mapOrderData);
          this.type = 2;
          // switch (this.info.validCode) {
          //   case 15:
          //     this.type = 2;
          //     break;
          //   case 16:
          //     this.type = 2;
          //     break;
          //   case 17:
          //     this.type = 2;
          //     break;
          //   default:
          //     this.type = 3;
          //     Toast({
          //       className: "toast-msg",
          //       message: "订单不存在/等5分钟后查询(订单存在延迟)",
          //     });
          //     break;
          // }
        });
    },
    backHome(type) {
      this.type = type;
      this.orderText = null;
    },
    mapOrderData(orderData) {
      return {
        skuName: orderData.skuName || "",
        shopName: orderData.shopName || "",
        skuImg: orderData.imageUrl || "",
        finishTime: orderData.finishTime || orderData.orderPayTime || "",
        orderTime: orderData.orderTime || "",
        ordersStatus: orderData.validCodeDesc || "",
        mainOrderId: orderData.orderId || "",
        subOrderId: orderData.rawSubOrderId || "",
        traceType: orderData.traceType,
        validCode: orderData.validCode || 0,
        actualCosPrice: orderData.actualCosPrice,
        estimateCosPrice: orderData.estimateCosPrice,
        isSuccess: true,
        userUniqueCode: orderData.userUniqueCode || "",
      };
    },
  },
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
toast-msg {
  width: 10.3rem !important;
  border-radius: 0.2rem !important;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: bold !important;
  font-size: 0.7rem !important;
  color: #ffffff !important;
  padding: 0.5rem;
}
</style>
